const stack = []; // [{ id, enabled, refs, onDismiss, onEscape, closeOnOutside }]

let listenersAttached = false;

function topEnabled() {
  for (let i = stack.length - 1; i >= 0; i--) {
    const item = stack[i];
    if (item && item.enabled) return item;
  }
  return null;
}

function isInside(e, refs) {
  const target = e.target;
  if (!target) return false;

  const path = typeof e.composedPath === "function" ? e.composedPath() : null;

  for (const r of refs || []) {
    const el = r?.current;
    if (!el) continue;
    if (path) {
      if (path.includes(el)) return true;
    } else {
      if (el.contains(target)) return true;
    }
  }
  return false;
}

function ensureListeners() {
  if (listenersAttached) return;
  listenersAttached = true;

  // pointerdown is the most reliable "outside" trigger for both mouse + touch
  document.addEventListener(
    "pointerdown",
    (e) => {
      const top = topEnabled();
      if (!top) return;
      if (!top.closeOnOutside) return;
      if (isInside(e, top.refs)) return;
      top.onDismiss?.(e);
    },
    true
  );

  document.addEventListener(
    "keydown",
    (e) => {
      if (e.key !== "Escape") return;
      const top = topEnabled();
      if (!top) return;
      (top.onEscape || top.onDismiss)?.(e);
    },
    true
  );
}

export function registerDismissableLayer(entry) {
  ensureListeners();
  stack.push(entry);

  return () => {
    const idx = stack.indexOf(entry);
    if (idx !== -1) stack.splice(idx, 1);
  };
}
